import script from "./ChangePasswordForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangePasswordForm.vue?vue&type=script&setup=true&lang=js"

import "./ChangePasswordForm.vue?vue&type=style&index=0&id=00e659e2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00e659e2"]])

export default __exports__